import { render, staticRenderFns } from "./LoyaltyStockUpdateComponent.vue?vue&type=template&id=494ac054&scoped=true"
import script from "./LoyaltyStockUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyStockUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ac054",
  null
  
)

export default component.exports